export const getRefState = (ref) => ref.current;

export const setRefState = (ref, value) => (ref.current = value);
